import _ from 'lodash'
import {
  ChartToolTip,
  Title,
  Item,
  ItemIcon
} from '..'
import { dollarFormat, numeralFormat } from '../../../../../../../lib/renderUtil'
import {
  getDashboardDateTime
} from '../../../../../../lib/MomentHelper'

const CustomizedTooltip = props => {
  const { active, payload, label: reportDate, format, isSaleDailyChart } = props
  const {
    name: amountName,
    value: amountValue,
    color: amountIconColor
  } = _.get(payload, '0', {})
  const {
    name: quantityName,
    value: quantityValue,
    color: quantityIconColor
  } = _.get(payload, '1', {})
  // 抓當日瀏覽量 pageViews
  const pageViewsValue = _.get(payload, '0.payload.pageView', '')
  const numberAmountValue = _.toNumber(amountValue)
  const numberQuantityValue = _.toNumber(quantityValue)
  const numberPageViewsValue = _.toNumber(pageViewsValue)
  if (active) {
    return (
      <ChartToolTip>
        <Title>
          {getDashboardDateTime(reportDate, format)}
        </Title>
        <Item>
          <ItemIcon color={amountIconColor} />
          {`${amountName} : ${dollarFormat(numberAmountValue)}`}
        </Item>
        <Item>
          <ItemIcon color={quantityIconColor} />
          {`${quantityName} : ${numeralFormat(numberQuantityValue, { allowZero: true })}`}
        </Item>
        {isSaleDailyChart && (
          <>
            <Item>
              {`平均客單 : $${numeralFormat(numberAmountValue / numberQuantityValue, { allowZero: true })}`}
            </Item>
            <Item>
              {`瀏覽量 : ${numeralFormat(numberPageViewsValue, { allowZero: true })}`}
            </Item>
          </>
        )}
      </ChartToolTip>
    )
  }
  return null
}

export default CustomizedTooltip
